import * as React from 'react';
import classNames from 'classnames';
import QRCode from 'qrcode';

import { ProjectTrans, Typography, useUiLabel } from '@canvas-logic/clp-shared-ui';

import ThemeDefinition from '../../domain/ThemeDefinition';

import style from './QrCodeDialog.module.css';

interface IProps {
  className?: string;
  link: string;
}

export const QrCodeDialog: React.FC<IProps> = ({ link, className }) => {
  const clickHereLabel = useUiLabel('ui.qrCode.clickHere');
  const canvasRef = React.createRef<HTMLCanvasElement>();

  React.useEffect(() => {
    if (canvasRef.current && link) {
      QRCode.toCanvas(canvasRef.current, link);
    }
  }, [link]);

  return (
    <div className={classNames(style.root, ThemeDefinition.qrCodeDialog.root, className)}>
      <canvas className={style.canvas} ref={canvasRef} />
      <div className={style.text}>
        <Typography variant="paragraph-md" color="description">
          <ProjectTrans
            labelKey="ui.qrCode.description"
            components={{
              lnk: (
                <a data-ar-link href={link}>
                  {clickHereLabel}
                </a>
              ),
            }}
          />
        </Typography>
      </div>
    </div>
  );
};
